// Card List Styling
function CardDokumen({number, title, subtitle = '',type = 'produktif'}){
    return(
        <div className='dokumen-pendukung-card'>
            <div className='number-section'>
                <p className={`${type}`}>{number}</p>
            </div>
            <div className='text-section'>
                <p className='title'>{title}</p>
                {subtitle === ''
                    ? <div/>
                    : <p>{subtitle}</p>
                }
            </div>
        </div>
    );
}

// Productive Card List
function DokumenPendukungProduktif({product}){
    if(product === 'invoice'){
        return(
            <CardDokumenInvoiceFinancing/>
        );
    }else if(product === 'inventory'){
        return(
            <CardDokumenInventoryFinancing/>
        );
    }else{
        return(
            <CardDokumenDeveloperFinancing/>
        );
    }
}
function CardDokumenInvoiceFinancing(){
    return (
        <div className='dokumen-container'>
            <CardDokumen number='1' title='Legalitas dan Perizinan Perusahaan' subtitle='Akta Pendirian dan Perubahan, NIB, NPWP, dll'/>
            <CardDokumen number='2' title='Mutasi Rekening Koran' subtitle='6 bulan terakhir'/>
            <CardDokumen number='3' title='Laporan Keuangan' subtitle='3 tahun terakhir'/>
            <CardDokumen number='4' title='KTP dan NPWP' subtitle='Milik pengurus dan pemegang saham'/>
            <CardDokumen number='5' title='Nomor Kontak Telepon & Alamat Email' subtitle='Milik perusahaan dan pengurus'/>
            <CardDokumen number='6' title='Profil Perusahaan'/>
            <CardDokumen number='7' title='Daftar Piutang/AR'/>
            <CardDokumen number='8' title='Daftar Supplier dan Customer'/>
            <CardDokumen number='9' title='Copy Invoice' subtitle='Yang akan dibiayai, beserta PO/Kontrak'/>
            <CardDokumen number='10' title='History Invoice' subtitle='Dengan customer/bouwheer yang diajukan'/>
            <CardDokumen number='11' title='Surat Permohonan Pengajuan Kredit'/>
            <CardDokumen number='12' title='Surat Formulir Persetujuan Pelanggan'/>
            <CardDokumen number='13' title='Dokumen Pendukung Lainnya' subtitle='Jika disyaratkan sesuai hasil review kredit'/>
        </div>
    );
}
function CardDokumenInventoryFinancing(){
    return (
        <div className='dokumen-container'>
            <CardDokumen number='1' title='Legalitas dan Perizinan Perusahaan' subtitle='Akta Pendirian dan Perubahan, NIB, NPWP, dll'/>
            <CardDokumen number='2' title='Mutasi Rekening Koran' subtitle='6 bulan terakhir'/>
            <CardDokumen number='3' title='Laporan Keuangan' subtitle='3 tahun terakhir'/>
            <CardDokumen number='4' title='KTP dan NPWP' subtitle='Milik pengurus dan pemegang saham'/>
            <CardDokumen number='5' title='Nomor Kontak Telepon & Alamat Email' subtitle='Milik perusahaan dan pengurus'/>
            <CardDokumen number='6' title='Profil Perusahaan'/>
            <CardDokumen number='7' title='Daftar Inventory' subtitle='yang dijaminkan'/>
            <CardDokumen number='8' title='Surat Permohonan Pengajuan Kredit'/>
            <CardDokumen number='9' title='Surat Formulir Persetujuan Pelanggan'/>
            <CardDokumen number='10' title='Dokumen Pendukung Lainnya' subtitle='Jika disyaratkan sesuai hasil review kredit'/>
        </div>
    );
}
function CardDokumenDeveloperFinancing(){
    return (
        <div className='dokumen-container'>
            <CardDokumen number='1' title='Legalitas dan Perizinan Perusahaan' subtitle='Akta Pendirian dan Perubahan, NIB, NPWP, dll'/>
            <CardDokumen number='2' title='Mutasi Rekening Koran' subtitle='6 bulan terakhir'/>
            <CardDokumen number='3' title='Laporan Keuangan' subtitle='3 tahun terakhir'/>
            <CardDokumen number='4' title='KTP dan NPWP' subtitle='Milik pengurus dan pemegang saham'/>
            <CardDokumen number='5' title='Nomor Kontak Telepon & Alamat Email' subtitle='Milik perusahaan dan pengurus'/>
            <CardDokumen number='6' title='Profil Perusahaan'/>
            <CardDokumen number='7' title='Sertifikat'/>
            <CardDokumen number='8' title='Rencana Anggaran Biaya (RAB)' subtitle='Serta design unit, site plan project, jadwal penyelesaian proyek'/>
            <CardDokumen number='9' title='Copy Persetujuan Bangunan Gedung (PBG)' subtitle='Minimal resi pengurusan'/>
            <CardDokumen number='10' title='Surat Permohonan Pengajuan Kredit'/>
            <CardDokumen number='11' title='Surat Formulir Persetujuan Pelanggan'/>
            <CardDokumen number='12' title='Dokumen Pendukung Lainnya' subtitle='Jika disyaratkan sesuai hasil review kredit'/>
        </div>
    );
}

// Consumptive Card List
function DokumenPendukungKonsumtif({product}){
    if(product === 'kasbon' || product === 'pinjaman-karyawan'){
        return(
            <CardDokumenPinjamanKaryawan/>
        );
    }else{
        return(
            <CardDokumenKMG/>
        );
    }
}
function CardDokumenPinjamanKaryawan(){
    return (
        <div className='dokumen-container'>
            <CardDokumen number='1' title='Memiliki e-KTP' subtitle='Pulau Jawa' type='individu'/>
            <CardDokumen number='2' title='Slip Gaji' type='individu'/>
            <CardDokumen number='3' title='NPWP' subtitle='Jika ada' type='individu'/>
        </div>
    );
}
function CardDokumenKMG(){
    return (
        <div className='dokumen-container'>
            <CardDokumen number='1' title='Memiliki e-KTP' subtitle='Pulau Jawa' type='individu'/>
            <CardDokumen number='2' title='Slip Gaji' type='individu'/>
            <CardDokumen number='3' title='NPWP' type='individu'/>
            <CardDokumen number='4' title='Kartu Keluarga' type='individu'/>
            <CardDokumen number='5' title='Surat/Buku Nikah' type='individu'/>
            <CardDokumen number='6' title='Sertifikat Tanah/Rumah' type='individu'/>
        </div>
    );
}
export default function CardDokumenPendukung({type ='',product = ''}) {
    return (
        <div className='container-alur'>
            <div className='dokumen-pendukung'>
                <div className='text-container'>
                    <h2 className='text-header'>Dokumen Pendukung</h2>
                </div>
                {type === 'individu'
                    ? <DokumenPendukungKonsumtif product={product}/>
                    : <DokumenPendukungProduktif product={product}/>
                }
            </div>
        </div>
    );
}